import type { GetKudosOrders } from '@fourthwall/services/dist/KudosApiClient'

import type { State } from '../ThankYous.types'

export const createOrdersQueryParams = (
  page: number,
  activeTab: State,
): GetKudosOrders['QueryParams'] => ({
  page: page - 1,
  size: 7,
  state: [activeTab],
  sortOrder: 'UPDATED_DESC',
  includeThankYouData: activeTab === 'SENT',
})
